<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YA91m8/tc-custom/9781401690649.jpg?1708485408459" alt="This image is the cover for the book Forever Christmas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forever Christmas
      </h1>
      <p class="bookDescription body article font2">
        <p><b>This Christmas will change Andrew Farmer’s life forever.</b></p><p>Andrew can’t remember the last time he spent Christmas away from work. The end of the year is crunch time for literary agents. But when your career is your life, your life starts to suffer . . . beginning with your marriage.</p><p>When a heart-wrenching accident in a Christmas Eve snowstorm jars this high-powered agent from his obsession with success, a Christmas miracle will give him a second chance at love, life, and gratitude, but only if he can put aside his own ambition and learn to appreciate each moment.</p><p>Sometimes it takes a tragedy to change a man’s life—and to teach him to treat every day as if it were his last.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Tate Miller
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?53be7ee0